import styles from "./CircleNode.module.scss";
import Icon from "components/common/elements/Icon";

const CircleNode = ({ focus, style }) => {
  return (
    <div
      className={styles.wrapper}
      onClick={focus}
      style={style}
    >
      <div className={styles.main}>
        <div className={styles.name}>
          <Icon
            icon="end-node"
            size={40}
          />
        </div>
      </div>
    </div>
  );
};

export default CircleNode;
